import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {
    FormWrapper,
    ContainerStyled
} from '../../containers/DefaultStyles/AssessmentDetails';
import { Body } from '../../containers/DefaultStyles/Details';
import { styledScrollbar } from '../Shared/mixins';
import { getImageUrl } from '../../utils/imageLoading';
import ThemeContext from '../../utils/theming';

export const volunteerMatchLogoURL = getImageUrl(
    'volunteermatch.png',
    'DEFAULT_IMAGES_URL'
);

export const ScrollBody = styled(Body)``;

export const Container = styled(ContainerStyled)`
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
`;

export const VolunteerFormWrapper = styled(FormWrapper)`
    width: 100%;
    @media (min-width: 355px) {
        height: 390px !important;
    }
`;

export const FormHeader = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const Title = styled.h1`
    margin: 0;
    font-size: 28px;
    line-height: 1.33;
    font-weight: 300;
    margin-bottom: 5px;
`;

export const ParentOrg = styled.h3`
    font-family: Lato;
    margin: 0;
    font-size: 14px;
    line-height: 1.33;
    font-weight: 800;
    text-transform: uppercase;
    color: #000000;
`;

export const About = styled.p`
    margin: 0;
    margin-top: 6px;
    font-size: 11px;
    line-height: 1.33;
    font-weight: 800;
    text-transform: uppercase;
`;

export const Step = styled.p`
    font-size: 10px;
    color: #333333;
    font-weight: 300;
    text-transform: uppercase;
`;

export const DescriptionComponent = styled.p`
    margin: 5px 0;
    font-size: 14px;
    line-height: 1.33;
    font-weight: 400;
    overflow-y: ${props =>
        props.isExpanded || !props.isLongDescription ? `scroll` : `hidden`};
    overflow-x: hidden;
    flex: 1;
    ${({ theme }) => styledScrollbar(theme.colors.primary)};
`;

export const Description = props => {
    const theme = useContext(ThemeContext);
    return (
        <DescriptionComponent {...props} theme={theme}>
            {props.children}
        </DescriptionComponent>
    );
};

Description.propTypes = {
    children: PropTypes.object
};

export const SkillsIcon = ({ size }) => (
    <svg
        width={`${size || 10}px`}
        height={`${size || 10}px`}
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                transform="translate(-22.000000, -151.000000)"
                fill="#BBBBBB"
                fillRule="nonzero"
            >
                <path
                    d="M31.9480529,155.137423 C31.9131863,155.09177 31.8676932,155.064611 31.8113456,155.055992 L30.6198824,154.873746 C30.554801,154.66539 30.4658215,154.452771 30.3529895,154.235704 C30.4310233,154.127205 30.5481652,153.974239 30.7043924,153.776692 C30.8606196,153.579191 30.9712624,153.434936 31.036435,153.343745 C31.0711648,153.295994 31.0884043,153.246123 31.0884043,153.193994 C31.0884043,153.133268 31.073354,153.085563 31.0428428,153.050788 C30.886684,152.829412 30.5285769,152.460519 29.9686583,151.943997 C29.9167802,151.900602 29.8623709,151.878916 29.8060234,151.878916 C29.7408736,151.878916 29.6888131,151.898413 29.6497278,151.937452 L28.7252942,152.634077 C28.5472897,152.542885 28.3519772,152.462594 28.1394024,152.393158 L27.9571107,151.195312 C27.9527552,151.138896 27.9277625,151.092217 27.882201,151.055321 C27.8365711,151.01838 27.7835072,151 27.7226445,151 L26.2773549,151 C26.1514793,151 26.0733315,151.060726 26.0429799,151.182268 C25.9865411,151.399198 25.9235805,151.802843 25.8541665,152.393135 C25.650143,152.458353 25.4526642,152.54081 25.2617072,152.640621 L24.3632697,151.943997 C24.3068537,151.900602 24.2504377,151.878916 24.1940217,151.878916 C24.0985432,151.878916 23.8934936,152.034071 23.5788045,152.344404 C23.2641153,152.654805 23.0504688,152.888062 22.9375228,153.044243 C22.8984374,153.100659 22.8789632,153.150599 22.8789632,153.193994 C22.8789632,153.246123 22.9006266,153.298206 22.9440218,153.350221 C23.23479,153.701851 23.4670442,154.001238 23.6406705,154.248748 C23.5321484,154.448369 23.4475244,154.64806 23.3868213,154.847682 L22.1758382,155.029927 C22.1281104,155.038638 22.0869044,155.066892 22.0521517,155.114642 C22.0173307,155.162347 22,155.21231 22,155.264302 L22,156.709657 C22,156.766164 22.0173307,156.817038 22.0520833,156.862623 C22.086836,156.908184 22.1323747,156.93548 22.1888135,156.944077 L23.3802995,157.119892 C23.4410253,157.332534 23.529982,157.547298 23.6471923,157.76425 C23.5691129,157.872818 23.4519255,158.025761 23.2956755,158.223262 C23.1394483,158.420855 23.0286686,158.565064 22.9636328,158.65621 C22.9288574,158.704143 22.9115267,158.753923 22.9115267,158.806029 C22.9115267,158.862376 22.9267139,158.912248 22.9570654,158.955643 C23.1263362,159.190154 23.4843977,159.554736 24.0313183,160.049504 C24.0790918,160.097255 24.1333642,160.121062 24.1940673,160.121062 C24.2592171,160.121062 24.3134667,160.101633 24.3568391,160.062616 L25.2748876,159.365901 C25.4529378,159.457046 25.6482047,159.53736 25.8608707,159.606888 L26.0431395,160.804734 C26.0475406,160.861081 26.0724877,160.90776 26.1180036,160.944747 C26.1635423,160.981734 26.2167659,161 26.2775145,161 L27.7228042,161 C27.8489078,161 27.9269416,160.939297 27.9573844,160.817709 C28.013732,160.600756 28.0766242,160.197157 28.146061,159.606888 C28.3500617,159.541716 28.5475633,159.459213 28.7385203,159.359356 L29.6370262,160.062616 C29.697752,160.101656 29.7542593,160.121062 29.8062286,160.121062 C29.9016843,160.121062 30.1056621,159.967092 30.4181165,159.658834 C30.7307305,159.350736 30.9455628,159.116339 31.0626363,158.955643 C31.1016532,158.91227 31.1212187,158.862376 31.1212187,158.806029 C31.1212187,158.749522 31.0996237,158.695158 31.0560689,158.643235 C30.7437057,158.261185 30.5114515,157.96182 30.3595114,157.744731 C30.4463017,157.584126 30.5309713,157.386693 30.6134518,157.152296 L31.8178674,156.970141 C31.8698367,156.961407 31.9133915,156.933154 31.9480301,156.885403 C31.9827599,156.837561 31.9999994,156.787622 31.9999994,156.735561 L31.9999994,155.290366 C32.0001135,155.23395 31.982874,155.18303 31.9480529,155.137423 Z M28.1783807,157.178312 C27.8529555,157.503874 27.4601468,157.666667 27,157.666667 C26.5398988,157.666667 26.1471357,157.503874 25.8215737,157.178312 C25.4961257,156.852887 25.3333333,156.460056 25.3333333,156 C25.3333333,155.539899 25.4960345,155.147136 25.8215737,154.821574 C26.1471357,154.496126 26.5399673,154.333333 27,154.333333 C27.4601468,154.333333 27.8529783,154.496126 28.1783807,154.821574 C28.5038743,155.147136 28.6666667,155.539899 28.6666667,156 C28.6666667,156.460056 28.5038971,156.85291 28.1783807,157.178312 Z"
                    id="icon_skills"
                />
            </g>
        </g>
    </svg>
);

SkillsIcon.propTypes = {
    size: PropTypes.number
};

export const LocationIcon = ({ size }) => (
    <svg
        width={`${size || 10}px`}
        height={`${size || 10}px`}
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                transform="translate(-23.000000, -133.000000)"
                fill="#BBBBBB"
                fillRule="nonzero"
            >
                <path
                    d="M30.8110043,135.787573 C30.821075,135.817596 31.000027,136.305423 31,136.444658 L31,136.972273 C31,138.256602 29.8203157,139.560747 29.0874173,140.854892 C29.0153559,140.984465 28.8576255,141.123726 28.7750613,141.262986 C28.6511881,141.472136 28.5075514,141.69113 28.3838132,141.910254 C27.9297915,142.656915 27.4668599,143.433496 27.0022544,144.2 C26.2487825,143.025429 25.4882637,141.850363 24.7553383,140.655845 C24.0740897,139.54093 23.1619153,138.356021 23.0172526,137.241107 C23.0071278,137.151478 23,136.972299 23,136.952353 L23,136.474395 C23.2580602,134.134965 25.1909734,133 26.9459607,133 C28.2569431,133 29.8805513,133.617244 30.6236285,135.33956 C30.6857271,135.47895 30.7696682,135.638157 30.8110043,135.787573 Z M26.9959096,138.52041 C28.0695269,138.52041 28.9398656,137.681008 28.9398656,136.645554 C28.9398656,135.610099 28.0695269,134.770697 26.9959096,134.770697 C25.9222923,134.770697 25.0519536,135.610099 25.0519536,136.645554 C25.0519536,137.681008 25.9222923,138.52041 26.9959096,138.52041 Z"
                    id="icon_location"
                />
            </g>
        </g>
    </svg>
);

LocationIcon.propTypes = {
    size: PropTypes.number
};
